import { autoinject } from 'aurelia-framework'
import { DialogController } from 'aurelia-dialog';

@autoinject()
export class BioDialog {
  public name: string;

  constructor(
    private dialogController: DialogController
  ) {}

  public activate(name: any): void {
    this.name = name;
  }

  public close(): void {
    this.dialogController.cancel();
  }
}